import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import actions from "@/actions";
import { GetWeathersResult } from "@/components/header/Weather/actions/types";
import { Weather } from "@/models/weather";
import { RootState } from "@/reducers/types";

export const useWeather = () => {
  const dispatch = useDispatch();
  const [current, setCurrent] = useState<Weather>();
  const [forecast, setForecast] = useState<Weather[]>([]);

  const menu = useSelector((state: RootState) => state.app.menu);

  useEffect(() => {
    search();
  }, [menu]);

  const search = useMemo(
    () =>
      _.debounce(() => {
        dispatch(
          actions.weather.getWeathers((res: GetWeathersResult) => {
            if (!res || !res.current_weather) {
              setCurrent(null);
              setForecast([]);
              return;
            }
            setCurrent(res.current_weather);
            if (res.weather_forecasts[0]) {
              // 直近6件までの表示とする
              setForecast(res.weather_forecasts.slice(0, 6));
            }
          })
        );
      }, 300),
    []
  );

  return {
    current,
    forecast,
  };
};
